import WebApp from "@twa-dev/sdk";

const hexToRGB = (hex) => {
    let fullHex = hex;
    // If hex is short, make it double
    if (hex.length === 4) {
        fullHex = hex.replace(/([^#])/g, '$1$1');
    }
    const bigint = parseInt(fullHex.replace('#', ''), 16);
    const channelR = bigint >> 16;
    const channelG = bigint >> 8;
    return [
        channelR & 255,
        channelG & 255,
        bigint & 255
    ];
};

const getBrightness = (color) => {
    const rgb = hexToRGB(color);

    //http://www.w3.org/TR/AERT#color-contrast
    return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
}

export const resolveBackgroundColor = () => {
    let bgColor = window.getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-bg-color');
    let bgSecondaryColor = window.getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-secondary-bg-color');
    let bgSectionColor = window.getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-section-bg-color');
    let bgColorBrightness = getBrightness(bgColor);
    let bgSecondaryColorBrightness = getBrightness(bgSecondaryColor);
    if (bgColorBrightness < bgSecondaryColorBrightness) {
        document.documentElement.style.setProperty('--tg-theme-bg-color', bgSecondaryColor.toString());
        document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', bgColor.toString());
        WebApp.setHeaderColor('bg_color');
    } else {
        WebApp.setHeaderColor('secondary_bg_color');
    }
    // if mod diff is less than 15, then we need to change the header color
    if (Math.abs(bgColorBrightness - bgSecondaryColorBrightness) < 15) {
        document.documentElement.style.setProperty('--tg-theme-bg-color', bgSectionColor.toString());
    }
    WebApp.onEvent("themeChanged", resolveBackgroundColor);
};
